/**
 * Summary section definitions and their visibility on knowledge cards.
 *
 * Each entry maps a section name (as it appears in the markdown summary)
 * to whether it should be displayed on the KnowledgeCard.
 */
export const SUMMARY_SECTIONS = {
  'Overview': { showOnCard: false },
  'Abstract': { showOnCard: true, displayName: 'Summary', translationKey: 'dashboard:summary' },
  'Context & Background': { showOnCard: false },
  'Main Content': { showOnCard: false },
  'Key Takeaways': { showOnCard: true },
};

/**
 * Check whether a section should be visible on the knowledge card.
 */
export function isSectionVisibleOnCard(sectionName) {
  const entry = SUMMARY_SECTIONS[sectionName];
  if (!entry) return true; // unknown sections default to visible
  return entry.showOnCard;
}

/**
 * Get the display name for a section (e.g. "Abstract" → "Summary").
 * Returns the original name if no override is configured.
 */
export function getSectionDisplayName(sectionName, t) {
  const entry = SUMMARY_SECTIONS[sectionName];
  if (!entry?.displayName) return sectionName;
  if (t && entry.translationKey) {
    return t(entry.translationKey, { defaultValue: entry.displayName });
  }
  return entry.displayName;
}
